<div class="ui basic padded fitted horizontally segment">
  <div>
    <div class="ui threaded comments">
      <div class="comment">
        <a class="avatar">
          <img src="https://react.semantic-ui.com/images/avatar/small/matt.jpg"
        /></a>
        <div class="content">
          <a class="author">Matt</a>
          <div class="metadata">
            <span>Today at 5:42PM</span>
          </div>
          <div class="text">How artistic!</div>
          <div class="actions">
            <a>Reply</a>
          </div>
        </div>
      </div>
      <div class="comment">
        <a class="avatar">
          <img
            src="https://react.semantic-ui.com/images/avatar/small/elliot.jpg"
        /></a>
        <div class="content">
          <a class="author">Elliot Fu</a>
          <div class="metadata">
            <span>Yesterday at 12:30AM</span>
          </div>
          <div class="text">
            <p>This has been very useful for my research. Thanks as well!</p>
          </div>
          <div class="actions">
            <a>Reply</a>
          </div>
        </div>
        <div class="ui comments">
          <div class="comment">
            <a class="avatar">
              <img
                src="https://react.semantic-ui.com/images/avatar/small/jenny.jpg"
            /></a>
            <div class="content">
              <a class="author">Jenny Hess</a>
              <div class="metadata">
                <span>Just now</span>
              </div>
              <div class="text">Elliot you are always so right :)</div>
              <div class="actions">
                <a>Reply</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment">
        <a class="avatar"
          ><img src="https://react.semantic-ui.com/images/avatar/small/joe.jpg"
        /></a>
        <div class="content">
          <a class="author">Joe Henderson</a>
          <div class="metadata"><span>5 days ago</span></div>
          <div class="text">Dude, this is awesome. Thanks so much</div>
          <div class="actions"><a>Reply</a></div>
        </div>
      </div>
      <form class="ui reply form">
        <div class="field">
          <textarea rows="3"></textarea>
        </div>
        <button class="ui icon primary left labeled button">
          <i aria-hidden="true" class="edit icon"></i>Add Reply
        </button>
      </form>
    </div>
  </div>
</div>
